import '../../../../lib/skeleton/style';
